import Vue from 'vue'
import Vuex from 'vuex'

import events from '@/store/modules/events'
import judges from '@/store/modules/judges'
import user from '@/store/modules/user'
import myEvents from '@/store/modules/myEvents'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		events,
		judges,
		user,
		myEvents
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js